import Api from '../api';
import { Url } from '../../constants/environment';

class ServiceableBannerService extends Api {
  constructor() {
    super();
  }

  async getList(space) {
    const res = await this.commonAjax('get', Url.named, `banner/serviceable?space=${space}`);
    return res;
  }
}

export default new ServiceableBannerService();
